const NO_TRANSLATE_X = 0;
const MATRIX_2D_TRANSLATE_X_INDEX = 4;
const MATRIX_3D_TRANSLATE_X_INDEX = 12;

type MarqueeAnimationDelayOptions = {
  currentX: number;
  duration: number;
  scrollWidth: number;
};

type LegacyWindow = Window & {
  WebKitCSSMatrix?: new (transform: string) => { m41: number };
};

const getParsedMatrixTranslateX = (serializedValues: string, index: number): number => {
  const values = serializedValues.split(',').map((value) => Number(value.trim()));
  const translateX = values[index];

  return Number.isFinite(translateX) ? translateX : NO_TRANSLATE_X;
};

export const getTranslateXFromElement = (element: HTMLDivElement): number => {
  const transform = window.getComputedStyle(element).transform;
  if (!transform || transform === 'none') return NO_TRANSLATE_X;

  try {
    if (typeof DOMMatrix === 'function') {
      return new DOMMatrix(transform).m41;
    }

    const { WebKitCSSMatrix } = window as LegacyWindow;
    if (typeof WebKitCSSMatrix === 'function') {
      return new WebKitCSSMatrix(transform).m41;
    }
  } catch (_error) {
    // Fall back to matrix string parsing.
  }

  const matrix3dMatch = transform.match(/^matrix3d\((.+)\)$/);
  if (matrix3dMatch?.[1]) {
    return getParsedMatrixTranslateX(matrix3dMatch[1], MATRIX_3D_TRANSLATE_X_INDEX);
  }

  const matrixMatch = transform.match(/^matrix\((.+)\)$/);
  if (matrixMatch?.[1]) {
    return getParsedMatrixTranslateX(matrixMatch[1], MATRIX_2D_TRANSLATE_X_INDEX);
  }

  return NO_TRANSLATE_X;
};

export const getMarqueeAnimationDelay = ({
  currentX,
  duration,
  scrollWidth,
}: MarqueeAnimationDelayOptions): number => {
  const halfWidth = scrollWidth / 2;
  if (halfWidth <= 0) return NO_TRANSLATE_X;

  const progress = currentX / -halfWidth;
  return -(progress * duration);
};
